<template>
  <CRow>
    <CCol sm="12" md="6" lg="5">
      <CCard>
        <CCardBody>
          <div class="add-weight">
            <div class="add-weight__label">Spremi tezinu {{ weight.toFixed(1) }}</div>
            <div class="add-weight__actions">
              <CButton color="info" class="add-weight__icon-button" @click="decreaseWeight">
                <CIcon name="cil-minus" />
              </CButton>
              <CButton color="info" class="add-weight__icon-button" @click="increaseWeight">
                <CIcon name="cil-plus" />
              </CButton>
              <CButton class="save-button" color="info" @click="onSaveWeightClick">Spremi</CButton>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import moment from "moment";
import { services } from "../services/services";

const roundWeight = (value) => Math.round(Number(value) * 10) / 10;

export default {
  data() {
    return {
      weight: 0,
    };
  },
  methods: {
    decreaseWeight() {
      this.weight = roundWeight(this.weight - 0.1);
    },
    increaseWeight() {
      this.weight = roundWeight(this.weight + 0.1);
    },
    onSaveWeightClick() {
      const date = moment().startOf("day");
      const dateText = date.format("YYYY-MM-DD");
      const roundedWeight = roundWeight(this.weight);
      services.addCurrentUserWeight(roundedWeight, dateText).then(() => {
        this.$store.commit("addNewWeight", { value: roundedWeight, date });
        this.$router.push({ path: "/weight-history" });
      });
    },
  },
  mounted() {
    this.weight = roundWeight(this.$store.state.weightHistory[this.$store.state.weightHistory.length - 1].value);
  },
};
</script>

<style scoped>
.add-weight {
  display: grid;
  gap: 1rem;
}

.add-weight__label {
  font-family: var(--font-display);
  font-size: 1rem;
  font-weight: 600;
  color: #334155;
}

.add-weight__actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.add-weight__icon-button {
  min-width: 3rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.save-button {
  font-size: 1rem;
  min-width: 7rem;
}

@media (max-width: 575px) {
  .add-weight__actions {
    flex-wrap: wrap;
  }

  .save-button {
    width: 100%;
  }
}
</style>
